export function addIfNotExists<T>(values: T[], toAdd: T) {
  if (!values.includes(toAdd)) {
    return values.concat([toAdd]);
  }
  return values;
}

export function removeIfExists<T>(values: T[], toRemove: T) {
  if (values.includes(toRemove)) {
    return values.filter((predValue) => predValue !== toRemove);
  }
  return values;
}

export function addOrRemove<T>(
  values: T[],
  toAddOrRemove: T,
  shouldAdd: boolean
) {
  if (shouldAdd) {
    return addIfNotExists(values, toAddOrRemove);
  } else {
    return removeIfExists(values, toAddOrRemove);
  }
}
